(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tg26-jalp-cart-loaf-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
  let adding = false;
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-jalp-loaf-form]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (adding) return;
    const root = form.closest('[data-jalp-loaf-upsell]');
    const error = root.querySelector('[data-jalp-loaf-error]');
    const button = form.querySelector('button');
    const expired = Number(root.dataset.cutoff) > 0 && Date.now() >= Number(root.dataset.cutoff) * 1000;
    if (root.dataset.ordersOpen !== 'true' || expired) {
      error.textContent = root.dataset.closed;
      error.hidden = false;
      button.disabled = true;
      return;
    }
    const drawer = form.closest('cart-drawer');
    const sections = ['tg26-cart-drawer', 'tg26-cart-icon-bubble'];
    const pageSections = ['main-cart-items', 'main-cart-footer'].map(id => ({ id, section: document.getElementById(id)?.dataset.id })).filter(item => item.section);
    sections.push(...pageSections.map(item => item.section));
    const locked = [...document.querySelectorAll('[data-jalp-loaf-form] button, [name="checkout"]')].map(element => ({ element, disabled: element.disabled }));
    const label = button.textContent;
    adding = true;
    locked.forEach(({ element }) => { element.disabled = true; });
    button.textContent = root.dataset.adding;
    form.setAttribute('aria-busy', 'true');
    error.hidden = true;
    let added = false;
    try {
      const response = await fetch(form.action.replace(/\.js$/, '') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: Number(form.elements.quantity.value) }], sections, sections_url: window.location.pathname }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : root.dataset.error);
      added = true;
      for (const item of pageSections) {
        const source = new DOMParser().parseFromString(result.sections?.[item.section] || '', 'text/html').querySelector(`#${item.id} .js-contents`);
        const target = document.querySelector(`#${item.id} .js-contents`);
        if (!source || !target) throw new Error('section_missing');
        target.innerHTML = source.innerHTML;
      }
      if (drawer) {
        drawer.renderContents(result);
      } else {
        const updatedDrawer = new DOMParser().parseFromString(result.sections?.['tg26-cart-drawer'] || '', 'text/html').querySelector('#CartDrawer');
        if (updatedDrawer) document.querySelectorAll('[data-jalp-cart-count]').forEach(counter => { counter.textContent = updatedDrawer.dataset.cartCount; });
        document.querySelector('#main-cart-footer [data-jalp-loaf-form] button, #checkout')?.focus();
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', sourceElement: 'CART-ITEMS' });
      }
    } catch (cause) {
      if (added) { window.location.assign(window.routes?.cart_url || '/cart'); return; }
      error.textContent = cause?.message || root.dataset.error;
      error.hidden = false;
    } finally {
      adding = false;
      locked.forEach(({ element, disabled }) => { element.disabled = disabled; });
      button.textContent = label;
      form.setAttribute('aria-busy', 'false');
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
